import { mapState } from 'vuex';
import f from '@/application/shared/functions.js'

export default {
    name: 'setpayment_tinkoff',
    props: {
        info : Object,
        value : Number,
        description : String,
        customer : String,
        count : Number
    },

    data : function(){

        return {
            loading : false
        }

    },

    mounted(){

        const TPF = document.getElementById("payform-tbank");

        TPF.addEventListener("submit", function (e) {

            e.preventDefault();
            
            const {description, amount, email, phone, DATA} = TPF;


            if (!email.value && !phone.value){
                return
            }

            var r = JSON.stringify({
                "EmailCompany": "maxgrishkov@gmail.com",
                "Taxation": "usn_income",
                "FfdVersion": "1.2",
                "Items": [
                    {
                        "Name": description.value || "Оплата",
                        "Price": Math.round((amount.value / (this.count || 1)) * 100),
                        "Quantity": this.count || 1,
                        "Amount": Math.round(amount.value * 100),
                        "PaymentMethod": "full_prepayment",
                        "PaymentObject": "service",
                        "Tax": "none",
                        "MeasurementUnit": "pc"
                    }
                ]
            });

            TPF.receipt.value = r

            pay(TPF)
        })
    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,
        userinfo : state => state.userinfo?.userinfo,
        locale : function(){
            return this.userinfo?.locale || 'ru'
        },
        email : function(){

            var e = this.userinfo?.email

            if(e && e.indexOf('***/') == -1){
                return e
            }

            return ''
        },
        phone : function(){

            var e = this.userinfo?.phone

            if(e && e.indexOf('***/') == -1){
                return e
            }

            return ''
        },

        terminalkey : function(){
            return f.deep(this.core, 'appInfo.terminals.tbank')
        }
    }),

    methods : {
        
    },
}